// extracted by mini-css-extract-plugin
export default {"wrapper":"yp-z","response":"zp-z","error":"Ap-z","disabled":"Bp-z","buttons":"Cp-z","feedbackQuestionSection":"Dp-z","yesNoWrapper":"Ep-z"};